import { render, staticRenderFns } from "./UserBillings.vue?vue&type=template&id=302bec23&scoped=true"
import script from "./UserBillings.vue?vue&type=script&lang=js"
export * from "./UserBillings.vue?vue&type=script&lang=js"
import style0 from "./UserBillings.vue?vue&type=style&index=0&id=302bec23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302bec23",
  null
  
)

export default component.exports